/**
 * Encodes a string using base64 encoding.
 *
 * @param str - The string to be encoded.
 * @returns The base64 encoded string.
 */
export const inlineBtoa = (str: string): string => Buffer.from(str, 'binary').toString('base64');
